import {
  useGetActivityLogQuery,
  logTitle,
  logDetail,
  logWhen,
  type EntityType,
} from '../features/activity/activityApi';

/** Change-log timeline for an entity, backed by /activity/log/. */
export default function ActivityHistoryPanel({
  entityId,
  entityType = 'Task',
}: {
  entityId: number | string;
  entityType?: EntityType;
}) {
  const { data: logs, isFetching } = useGetActivityLogQuery({ entityType, entityId });
  const items = logs ?? [];

  return (
    <div className="rounded-xl border border-line-soft bg-white p-6 shadow-card">
      <h2 className="text-base font-semibold text-ink">Activity History</h2>

      {items.length === 0 ? (
        <p className="mt-4 text-sm text-ink-secondary">
          {isFetching ? 'Loading…' : 'No activity yet.'}
        </p>
      ) : (
        <div className="mt-6 flex flex-col gap-6 border-l-2 border-[#f3f4f6] pl-5">
          {items.map((a, i) => {
            const active = i === 0; // most recent entry highlighted
            const detail = logDetail(a);
            return (
              <div key={a.id} className="relative">
                <span
                  className={[
                    'absolute rounded-full border-2 border-white',
                    active
                      ? '-left-[27px] top-0.5 size-4 bg-brand shadow-[0px_0px_0px_2px_rgba(15,82,186,0.2)]'
                      : '-left-[25px] top-1 size-3 bg-[#e5e7eb]',
                  ].join(' ')}
                />
                <div className="flex flex-col gap-1">
                  <span className={['text-sm font-medium', active ? 'text-brand' : 'text-ink'].join(' ')}>
                    {logTitle(a)}
                  </span>
                  {detail && <span className="text-xs text-[#64748b]">{detail}</span>}
                  {logWhen(a) && (
                    <span className="text-[10px] font-medium uppercase tracking-[0.25px] text-[#9ca3af]">
                      {logWhen(a)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
